// extracted by mini-css-extract-plugin
module.exports = {"localTimeLabel":"CurrentDateTime_localTimeLabel__EV2W_"};